import * as sizeManager from "@/modules/sizeManager";
import * as dimensionUtils from "@/common/utils/dimensionUtils";
import type { Size } from "@/common/utils/dimensionUtils";
import type { TemplateSizes } from "@/types/layout";

let showPanel = true;
let showControlBar = false;
let lastSize: Size | null = null;
let sizes: TemplateSizes | null = null;

export function setShowPanel(value: boolean) {
  if (showPanel !== value) {
    showPanel = value;
    // no need to change sizes = null;
  }
}

export function setShowControlBar(value: boolean) {
  if (showControlBar !== value) {
    showControlBar = value;
  }
}

export function getClientSize(_window?: Window): Size {
  _window = _window || window;
  return {
    width: _window.document.documentElement.clientWidth,
    height: _window.document.documentElement.clientHeight,
  };
}

export function getInnerWindowSize(_window?: Window): Size {
  _window = _window || window;
  return {
    width: _window.innerWidth,
    height: _window.innerHeight,
  };
}

export function getInnerScreenSize(_screen?: Screen): Size {
  _screen = _screen || screen;
  return {
    width: _screen.availWidth,
    height: _screen.availHeight,
  };
}

export function getScreenSize(): Size {
  const w = screen.width;
  const h = screen.height;

  return {
    width: w,
    height: h,
  };
}

export function getSizes(size?: Size | null): TemplateSizes {
  if (!size) {
    size = sizeManager.getSize();
  }

  if (!dimensionUtils.sizeEquals(size, lastSize)) {
    sizes = null;
    lastSize = size;
  }

  if (sizes == null) {
    const containerPadding = { left: 0, right: 0, bottom: 0, top: 0 };
    const headerMargins = { left: 0, right: 0, bottom: 3, top: 5 };
    const containerWidth = size.width;
    const containerHeight = size.height;
    const marginTop = 0.0;
    const marginLeft = 0.0;
    const videoWidth = Math.floor(
      size.width - containerPadding.left - containerPadding.right,
    );
    const videoHeight = Math.floor((videoWidth / 16) * 9);
    const headerRatio = 7.0;
    const headerHeight =
      Math.floor(videoWidth / headerRatio) +
      headerMargins.top +
      headerMargins.bottom;
    const panelWidth = videoWidth;
    const panelHeight = size.height - headerHeight - videoHeight;

    //
    // favorites
    //
    const favoritesPanelWidth = size.width;
    const favoritesPanelHeight = size.height;

    sizes = {
      player: {
        padding: containerPadding,
        container: {
          width: containerWidth,
          height: containerHeight,
          margins: { top: marginTop, left: marginLeft },
        },
        video: {
          width: videoWidth,
          height: videoHeight,
          margins: {
            left: containerPadding.left,
            top: containerPadding.top,
            right: containerPadding.right,
            bottom: 0,
          },
        },
        panel: {
          width: panelWidth,
          height: panelHeight,
          margins: {
            left: containerPadding.left,
            top: containerPadding.top,
            right: containerPadding.right,
            bottom: containerPadding.bottom,
          },
        },
      },

      favorites: {
        lightbox: {
          width: favoritesPanelWidth,
          height: favoritesPanelHeight,
          margins: containerPadding,
        },
      },
    };
  }

  return sizes;
}
